import { RecipeImpressionArgs } from '@woolworthsnz/styleguide';
import { ProductResponse, RecipeResponse, RecipeStamp } from '@woolworthsnz/trader-api';
import { RecipeStampLocal, Stamp } from '../models';

export function mapToStamps(recipeList: RecipeStampLocal[]): Stamp[] {
	return recipeList.map((recipe) => ({ recipe }));
}

export function mapRecipeResponseToRecipeStampLocal(recipe: RecipeResponse): RecipeStampLocal {
	return {
		id: recipe.id || 0,
		title: recipe.title || '',
		mealTimes: recipe.mealtimes?.split(',') || [],
		prepDuration: recipe.prepDuration || null,
		cookDuration: recipe.cookingDuration || null,
		servings: recipe.servings || null,
		imageUrl: recipe.largeImageFilename || recipe.smallImageFilename || '',
		badge: null,
		saved: null,
		numberOfIngredients: recipe.ingredients?.length || 0,
	};
}

export function mapToRecipeStampLocal(recipe: RecipeStamp): RecipeStampLocal {
	return {
		id: recipe.recipeId || 0,
		title: recipe.title || '',
		mealTimes: recipe.mealtimes?.split(',') || [],
		prepDuration: recipe.prepDuration || null,
		cookDuration: recipe.cookingDuration || null,
		servings: recipe.servings || null,
		imageUrl: recipe.largeImageFileName || recipe.smallImageFileName || '',
		badge: recipe.promotion || null,
		saved: null,
		numberOfIngredients: recipe.numberOfIngredients || 0,
	};
}

export function isRecipeStamp(recipe: ProductResponse | RecipeStamp): recipe is RecipeStamp {
	return (<RecipeStamp>recipe).recipeId !== undefined;
}

export function saveButtonAriaLabel(title: string, saved: boolean): string {
	return saved ? `Remove ${title} from Saved Recipes` : `Add ${title} to Saved Recipes`;
}

export function createRecipeImpressionArgs(
	recipe: RecipeStampLocal,
	position: number,
	carouselName: string
): RecipeImpressionArgs {
	return {
		tealium_event: `recipe_carousel_${carouselName}`,
		interaction_source: 'page',
		recipe_name: [recipe?.title],
		recipe_id: [String(recipe?.id)],
		recipe_category: ['Recipes'],
		recipe_prep_time: [String(recipe?.prepDuration)],
		recipe_cook_time: [String(recipe?.cookDuration)],
		recipe_servings: [String(recipe?.servings)],
		carouselName,
		position,
	};
}
